import { render, staticRenderFns } from "./SfBanner.vue?vue&type=template&id=1da5d4af"
import script from "./SfBanner.vue?vue&type=script&lang=js"
export * from "./SfBanner.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBanner.vue?vue&type=style&index=0&id=1da5d4af&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "18dce15c"
  
)

export default component.exports